// extracted by mini-css-extract-plugin
module.exports = {"siteMarketingSection":"JoinFansiteMarketing_siteMarketingSection__uTzuK","description":"JoinFansiteMarketing_description__uRe_e"};